// extracted by mini-css-extract-plugin
module.exports = {"container":"StartPage__container","contentGrid":"StartPage__contentGrid","eventGrid":"StartPage__eventGrid","fadeIn":"StartPage__fadeIn"};